<template>
    <b-form-group
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <div v-if="isInline===true">
            <div v-if="presets.length > 0" style="width: 200px;" class="pull-left mr-1">
                <b-button-group vertical>
                    <b-button @click="setPreset(preset)" :key="presetIndex" v-for="preset, presetIndex in presets" class="mr-2" type="button" variant="light">
                        {{preset.label}}
                    </b-button>
                    <b-button v-if="dataValue!==null" class="mt-1 font-reduce" type="button" variant="info">
                        {{Core.Text.format(Core.Definition.getDefinition('{0} - {1}'), Vue.moment(dataValue.start).format('D MMM YYYY'), Vue.moment(dataValue.end).format('D MMM YYYY'))}}
                    </b-button>
                    <b-button class="mt-1 font-reduce" type="button" variant="light">
                        {{Core.Definition.getDefinition('Réinitialiser')}}
                    </b-button>
                </b-button-group>
            </div>
            <div class="pull-left">
                <date-picker
                    :mode="mode"
                    v-model="dataValue"
                    :color="color"
                    :locale="local"
                    :columns="$screens(columns)"
                    :is-dark="isDark"
                    :is-inline="isInline"></date-picker>
            </div>
        </div>
        <div v-if="isInline===false">
            <div v-if="presets.length > 0" style="width: 200px;" class="pull-left mr-1">
                <b-button-group vertical>
                    <b-button @click="setPreset(preset)" :key="presetIndex" v-for="preset, presetIndex in presets" class="mr-2" type="button" variant="light">
                        {{preset.label}}
                    </b-button>
                </b-button-group>
            </div>
            <div class="pull-left">
                <date-picker
                        :mode="mode"
                        v-model="dataValue"
                        :color="color"
                        :locale="local"
                        :columns="$screens(columns)"
                        :is-dark="isDark"
                        :is-inline="isInline"></date-picker>
                <b-button-group>
                    <b-button v-if="dataValue!==null" class="mt-1 font-reduce" type="button" variant="info">
                        {{Core.Text.format(Core.Definition.getDefinition('{0} - {1}'), Vue.moment(dataValue.start).format('D MMM YYYY'), Vue.moment(dataValue.end).format('D MMM YYYY'))}}
                    </b-button>
                    <b-button class="mt-1 font-reduce" type="button" variant="light">
                        {{Core.Definition.getDefinition('Réinitialiser')}}
                    </b-button>
                </b-button-group>
            </div>
        </div>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import Vue from 'vue'
    import Calendar from 'v-calendar/lib/components/calendar.umd'
    import DatePicker from 'v-calendar/lib/components/date-picker.umd'

    // Register components in your 'main.js'
    Vue.component('calendar', Calendar)
    Vue.component('date-picker', DatePicker)

    export default {
      name: 'InputDateRangePicker',
        components: {
            Calendar,
            DatePicker
        },
      props: {
          presets: {
              type: Array,
              default: function() {
                  let defaultPresets = [
                      {
                          label: Core.Definition.getDefinition('3 prochains mois'),
                          start: Vue.moment().format('YYYY-MM-DD'),
                          end: Vue.moment().add(3, 'month').format('YYYY-MM-DD')
                      },
                      {
                          label: Core.Definition.getDefinition('6 prochains mois'),
                          start: Vue.moment().format('YYYY-MM-DD'),
                          end: Vue.moment().add(6, 'month').format('YYYY-MM-DD')
                      },
                      {
                          label: Core.Definition.getDefinition('Jusqu\'à la fin du mois'),
                          start: Vue.moment().format('YYYY-MM-DD'),
                          end: Vue.moment().endOf('month').format('YYYY-MM-DD')
                      },
                      {
                          label: Core.Definition.getDefinition('Jusqu\'à la fin de l\'année'),
                          start: Vue.moment().format('YYYY-MM-DD'),
                          end: Vue.moment().endOf('year').format('YYYY-MM-DD')
                      }
                  ]
                  return defaultPresets
              }
          },
          columns: {
              type: Object,
              default: function() {
                  return { default: 1, lg: 1 }
              }
          },
          mode: {
              type: String,
              default: 'range'
          },
          color: {
              type: String,
              default: 'gray'
          },
          isDark: {
              type: Boolean,
              default: false
          },
          isInline: {
              type: Boolean,
              default: true
          },
          required: {
              type: Boolean,
              default: false
          },
          local: {
              type: String,
              default: 'fr'
          },
          value: {
              type: Object,
              default: function() {
                  return null
              }
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              Vue: Vue,
              Core: window.Core,
              dataValue: null
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          },
          setPreset(preset) {
              this.dataValue = {
                  start: new Date(Vue.moment(preset.start)),
                  end: new Date(Vue.moment(preset.end))
              }
          }
      }
  }
</script>